<template>

  <div class="hero">
    <div class="hero-wrapper">
      <div class="background" :style="{'backgroundImage':'url(' + image + ')'}"></div>
    </div>
  </div>

</template>

<script>

export default {
  props: {
    image: {
      type: String,
      default () {
        return ''
      }
    }
  },
  data () {
    return {
      windowWidth: window.innerWidth
    }
  },
  methods: {
    handleWindowResize (event) {
      let self = this
      self.windowWidth = event.currentTarget.innerWidth
    },
    isMobile () {
      let self = this
      return self.windowWidth < 640
    }
  },
  beforeDestroy: function () {
    let self = this
    window.removeEventListener('resize', self.handleWindowResize)
  },
  mounted () {
    let self = this
    window.addEventListener('resize', self.handleWindowResize)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.hero {
  position: relative;
  margin-bottom: 0rem;
  overflow: hidden;
  max-height: 500px;
  max-height: 60vh;
}
.hero-wrapper {
  position: relative;
  margin: 0 0;
  width: 100%;
  max-width: 100%;
  padding-bottom: 50%;
  background: #000;
}
.hero-wrapper .background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
}

@media screen and (max-width: 1024px) {

}
@media screen and (max-width: 768px) {
  .hero {
    max-height: 400px;
  }
  .hero-wrapper {
    padding-bottom: 50%;
  }
}
@media screen and (max-width: 640px) {
  .hero {
    max-height: 300px;
  }
  .hero-wrapper {
    padding-bottom: 75%;
  }
}
</style>



// WEBPACK FOOTER //
// Hero.vue?457942c3